import { createContext, useContext } from 'react';

export type ReplaceableFileField = {
  key: string;
  label: string;
  stepKey: 'upload' | 'details' | 'preference' | 'author';
};

const PENDING_FILE_FIELD_KEY = 'submission-upload-pending-file-field';

export const FileReplacementNavigationContext = createContext<
  (field: ReplaceableFileField) => void
>(() => undefined);

export const useFileReplacementNavigation = () =>
  useContext(FileReplacementNavigationContext);

export const savePendingFileReplacement = (field: ReplaceableFileField) => {
  sessionStorage.setItem(PENDING_FILE_FIELD_KEY, JSON.stringify(field));
};

export const scrollToPendingFileField = (
  stepKey: ReplaceableFileField['stepKey']
) => {
  const pendingField = sessionStorage.getItem(PENDING_FILE_FIELD_KEY);
  if (!pendingField) return;

  let field: ReplaceableFileField;
  try {
    field = JSON.parse(pendingField) as ReplaceableFileField;
  } catch {
    sessionStorage.removeItem(PENDING_FILE_FIELD_KEY);
    return;
  }

  if (field.stepKey !== stepKey) return;

  let attempts = 0;
  const scrollToField = () => {
    const target = document.getElementById(field.label);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      sessionStorage.removeItem(PENDING_FILE_FIELD_KEY);
      return;
    }
    if (attempts < 20) {
      attempts += 1;
      requestAnimationFrame(scrollToField);
    }
  };

  requestAnimationFrame(scrollToField);
};
